import Typography from 'components/atoms/Typography';
import { ActionType } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/action';
import { HubAuthoringContext, HubAuthoringDispatchContext } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/reducer';
import { useContext } from 'react';
import { ToggleControlled } from 'components/molecules/Toggle';
import Select from 'components/molecules/Select';
import { orgTypeFilteringOptions } from 'utils/selectOptions';
import { SelectOption } from 'utils/frontendTypes';
import HubHeaderColorSettings from './HubHeaderColorSettings';

const HubVisibleInDiscoverControl = () => {
  const {
    hubUpsertParams: { visibleInDiscover },
  } = useContext(HubAuthoringContext);
  const dispatch = useContext(HubAuthoringDispatchContext);

  return (
    <div className="mb-4">
      <Typography className="text-sm text-glooCharcoal font-semibold pb-2" variant="base">
        Display In Discover
      </Typography>
      <ToggleControlled
        isChecked={visibleInDiscover}
        onChange={(value) => {
          dispatch({
            type: ActionType.setVisibleInDiscover,
            visibleInDiscover: value,
          });
        }}
      />
    </div>
  );
};

const HubOrgTypeFilteringControl = () => {
  const {
    hubUpsertParams: { orgTypeFiltering },
  } = useContext(HubAuthoringContext);
  const dispatch = useContext(HubAuthoringDispatchContext);

  return (
    <div className="mb-4">
      <Typography className="text-sm text-glooCharcoal font-semibold pb-2" variant="base">
        Org Type Filtering
      </Typography>
      <Select
        dataDurableId="orgTypeFilteringSelect"
        options={orgTypeFilteringOptions}
        onChange={(option: SelectOption) => {
          dispatch({
            type: ActionType.setOrgTypeFiltering,
            orgTypeFiltering: option.value,
          });
        }}
        value={orgTypeFilteringOptions.find((o) => o.value === orgTypeFiltering)}
      />
    </div>
  );
};

const HubDiscoverControls = () => (
  <div className="flex flex-col p-4">
    <HubVisibleInDiscoverControl />
    <HubOrgTypeFilteringControl />
    <HubHeaderColorSettings />
  </div>
);

export default HubDiscoverControls;
